import React from 'react';
import './Footer.css';
import { FaTwitter, FaInstagram, FaWhatsapp } from 'react-icons/fa'; // Ensure you have react-icons installed
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* LEFT SECTION: Social Icons */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="footer-section left"
        >
          <h1>Follow Us on:</h1>
          
          <div className="social-links-container">
            {/* X-Twitter */}
            <a href="https://x.com/Tours_Travel1" target="_blank" rel="noopener noreferrer" className="social-row">
              <span className="social-text">X-twitter</span>
              <FaTwitter className="social-icon" />
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/tourstravel640/" target="_blank" rel="noopener noreferrer" className="social-row">
              <span className="social-text">Instagram</span>
              <FaInstagram className="social-icon" />
            </a>

            {/* Whatsapp */}
            <a href="https://wa.me/+254720572184" target="_blank" rel="noopener noreferrer" className="social-row">
              <span className="social-text">Whatsapp</span>
              <FaWhatsapp className="social-icon" />
            </a>
          </div>
        </motion.div>

        {/* CENTER SECTION: Company Info */}
        <motion.div 
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="footer-section center"
        >
          <div className="company-info">
            <h2>Countryside Tours and Travel</h2>
            <p>Email Address1: <strong>info@travelapp.tours</strong></p>
            <p>Email Address2: <strong>bookings@travelapp.tours</strong></p>
            <p>Company Address: <strong>Nairobi, Kenya</strong></p>
            <p>Company Tel No: <strong>+254 720 572 184</strong></p>
          </div>
        </motion.div>

        {/* RIGHT SECTION: (Empty for balance, or add links here later) */}
        <div className="footer-section right"></div>

      </div>

      {/* COPYRIGHT BOTTOM */}
      <motion.div
        className="footer-bottom"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        <p>&copy; 2025 TravelApp. All rights reserved.</p>
      </motion.div>
    </footer>
  );
};

export default Footer;